let tradeIdeasTypes = {};

tradeIdeasTypes.status = (value) => {
  switch (value) {
    case "PENDING":
      return "Pendente";
    case "ACTIVE":
      return "Ativo";
    case "STOPPED":
      return "Parado";
    case "FINISHED":
      return "Executado";
    case "DELETED":
      return "Apagado";
    case "EXPIRED":
      return "Expirado";
    default:
      return value;
  }
};

export { tradeIdeasTypes };
